import Experiment from '@mc/experiments-react'
import { CM_TIMELINE_VIEW_FLAG_NAME } from '../constants'
import { Variant1PageContent } from '../pages/Variant1PageContent'
import { Variant2PageContent } from '../pages/Variant2PageContent'

export const CMTimelineViewExperiment = ({
  Control,
}: {
  Control: React.ReactNode
}) => (
  <Experiment
    name={CM_TIMELINE_VIEW_FLAG_NAME}
    control={() => Control}
    variant_1={Variant1PageContent}
    variant_2={Variant2PageContent}
  />
)
